import { getColor, rgbaColor } from '@/helpers/utils';
import { Col, Row } from 'react-bootstrap';

type MarketingExpenseItem = {
  name: string;
  value: number;
};

type MarketingExpensesData = {
  language?: MarketingExpenseItem[];
  tld?: MarketingExpenseItem[];
};

type ItemListProps = {
  data?: MarketingExpenseItem[];
  first?: boolean;
};

type MarketingExpensesListProps = {
  data?: MarketingExpensesData;
  /** Reserved rows so the preload matches a full grouped list (top 9 + Other). */
  placeholderCount?: number;
};

const ItemList = ({
  data = [],
  first = false,
  placeholderCount = 0
}: ItemListProps & { placeholderCount?: number }) => {
  const items = placeholderCount
    ? Array.from({ length: placeholderCount }, () => ({
        name: 'English',
        value: 0
      }))
    : data;

  return (
    <ul className="list-unstyled mb-0">
      {items.map((item, index) => (
        <li
          key={`${item?.name ?? 'row'}-${index}`}
          style={{ direction: 'ltr', textAlign: 'right' }}
          className={`d-flex align-items-center fs--2 gap-1 fw-medium pt-1 ${
            index !== items.length - 1 && 'mb-3'
          }`}
        >
          <span
            style={{
              backgroundColor: first
                ? rgbaColor(getColor('primary'), (index + 1) / items.length)
                : rgbaColor(getColor('info'), (index + 1) / items.length)
            }}
            className={`dot bg-opacity-50`}
          />
          <p className="lh-sm mb-0 text-700">
            {placeholderCount ? (
              <span className="invisible" aria-hidden>
                {item.name}
                <span className="text-900 mx-1 fw-bold ps-2">{item.value}</span>
              </span>
            ) : (
              <>
                {item.name}
                <span className="text-900 mx-1 fw-bold ps-2">{item.value}</span>
              </>
            )}
          </p>
        </li>
      ))}
    </ul>
  );
};

const MarketingExpensesList = ({
  data,
  placeholderCount = 0
}: MarketingExpensesListProps) => {
  return (
    <Row className="g-3 font-sans-serif">
      <Col sm={6}>
        <div className="rounded-3 border p-3 h-100">
          <div className="d-flex align-items-center mb-4">
            <span className="dot bg-primary bg-opacity-25" />
            <h6 className="mb-0 fw-bold">زبان</h6>
          </div>
          <ItemList
            data={data?.language ?? []}
            placeholderCount={placeholderCount}
          />
        </div>
      </Col>
      <Col sm={6}>
        <div className="rounded-3 border p-3">
          <div className="d-flex align-items-center mb-4">
            <span className="dot bg-info bg-opacity-25" />
            <h6 className="mb-0 fw-bold">پسوندها</h6>
          </div>
          <ItemList
            first
            data={data?.tld ?? []}
            placeholderCount={placeholderCount}
          />
        </div>
      </Col>
    </Row>
  );
};

export default MarketingExpensesList;
